/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessfulResponse as DigiworkMaitreDApiConfigurationModelSuccessfulResponse } from '../../models/Digiwork/MaitreD/Api/Configuration/Model/successful-response';

export interface DeleteSupplier$Params {
  supplierId: string;
}

export function deleteSupplier(http: HttpClient, rootUrl: string, params: DeleteSupplier$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteSupplier.PATH, 'delete');
  if (params) {
    rb.path('supplierId', params.supplierId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>;
    })
  );
}

deleteSupplier.PATH = '/api/suppliers/{supplierId}';
